export default function playerColorToHex(color: number): string {
  return '#' + (color || 0).toString(16).padStart(3, '0')
}